import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "リモートワークの有無")
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_section_inner" }
const _hoisted_4 = ["value"]

import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { JobSearchPublicDropdownData } from '@/types/mstMyPage';
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

// 親コンポーネントからのプロパティ定義

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoteWork',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: {
    id: number;
    text: string;
  }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: {
    id: number;
    text: string;
  }
}



const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const defaultValue = {
  id: 0,
  text: MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
};

// 親コンポーネントへのイベント定義


const listRemoteWork = ref<JobSearchPublicDropdownData[]>([]);
const selectedRemoteWork = ref<{
    id: number;
    text: string;
}>({...defaultValue});

// 選択値が変更されたときに親コンポーネントに通知
function emitSelectedValue() {
  const selectedOption = listRemoteWork.value.find(rmWork => Number(rmWork.id) === selectedRemoteWork.value.id);
  selectedRemoteWork.value.text = selectedOption ? selectedOption.text : '';

  emit('update:modelValue', selectedRemoteWork.value);
}

// propsからの初期値をwatchで監視
watch(() => props.modelValue, (newValue) => {
  if (newValue === null || newValue === undefined) {
    selectedRemoteWork.value = {...defaultValue};
  } else {
    const option = listRemoteWork.value.find(rmWork => Number(rmWork.id) === newValue.id);
    selectedRemoteWork.value = {
      id: newValue.id,
      text: option ? option.text : ''
    };
  }
}, { immediate: true, deep: true });

const store = useStore();
onMounted(async () => {
  const defaultOpt: JobSearchPublicDropdownData = {
    id: 0,
    text: '指定しない',
    value: '0'
  };
  const remoteWork = await store.dispatch(storeBase.MST_REMOTE_WORK_ORDER);
  listRemoteWork.value = [defaultOpt, ...remoteWork];

  // 初期値が設定されていない場合はデフォルト値を使用
  if (!selectedRemoteWork.value && listRemoteWork.value.length > 0) {
    if (props.modelValue){
      selectedRemoteWork.value = props.modelValue;
    } else {
      selectedRemoteWork.value = {...defaultValue};
    }
    // 初期値を親に通知
    emitSelectedValue();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "p-jobsearch-search_select overflow_hidden",
        size: "1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRemoteWork.value.id) = $event)),
        onChange: emitSelectedValue
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listRemoteWork.value, (rmWork) => {
          return (_openBlock(), _createElementBlock("option", {
            key: rmWork.id,
            value: rmWork.id
          }, _toDisplayString(rmWork.text), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, selectedRemoteWork.value.id]
      ])
    ])
  ]))
}
}

})